import { calculateDestinationDate } from "./fileNaming";
import { normalizeWindowsPath } from "./path";

export interface BuildContingencyExportPathParams {
	root: string;
	serviceFolder: string;
	horarioCorte?: string;
	delivery?: string;
}

/**
 * Fórmula 1C (contingência offline):
 * {raiz}\{ANO}\{MM-NOME_MES}\{DD-MM}\{SERVICO}\
 */
export function buildContingencyExportPath(
	params: BuildContingencyExportPathParams,
): string {
	const date = calculateDestinationDate(
		params.delivery ?? "Hoje",
		params.horarioCorte ?? "16:00",
	);

	let dir = `${params.root}\\${date.ano}\\${date.mes}\\${date.dataFormatada}\\${params.serviceFolder}`;
	if (date.subpastaNoturna) {
		dir += "\\NOTURNA";
	}

	return normalizeWindowsPath(dir);
}
